import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=87948736&scoped=true&"
import script from "./feature.js?vue&type=script&lang=js&"
export * from "./feature.js?vue&type=script&lang=js&"
import style0 from "./feature.css?vue&type=style&index=0&id=87948736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87948736",
  null
  
)

export default component.exports